import { createFileRoute } from "@tanstack/react-router"
import { createAccountStore } from "@/stores/account"

export const Route = createFileRoute("/report/report")({
  component: RouteComponent,
})

function RouteComponent() {
  const selectedIdfTeam = createAccountStore((state) => state.selectedIdfTeam)

  return (
    <iframe
      src={`${import.meta.env.VITE_LEGACY_WEB_URL}/report?teamId=${selectedIdfTeam}`}
      style={{
        width: "100%",
        height: "100%",
        border: "none",
      }}
    />
  )
}
